jQuery(($) => {
  if (!document.querySelector("main.manual")) {
    return;
  }

  document.querySelector(
    ".manual-top-title a"
  ).textContent = document
    .querySelector("title")
    .textContent.replace(/.* -/, "");
});
